export default __webpack_public_path__ + "media/EmptyTable.6a1db854.svg";